import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    authPractitioner: {
      namespaced: true,
      root: true,
      state: {
        status: "",
        practitioner: JSON.parse(localStorage.getItem("practitioner")) || {},
        fromUrl: ""
      },
      mutations: {
        auth_request(state) {
          state.status = "loading";
        },
        auth_success(state, { practitioner }) {
          state.status = "success";
          state.practitioner = practitioner;
        },
        auth_error(state) {
          state.status = "error";
        },
        logout(state) {
          state.status = "";
          state.practitioner = {};
        },
        setFromUrl(state, fromUrl) {
          state.fromUrl = fromUrl;
        },
        setPractitioner(state, practitioner) {
          state.practitioner = { ...state.practitioner, ...practitioner };
          localStorage.setItem(
            "practitioner",
            JSON.stringify(state.practitioner)
          );
        }
      },
      actions: {
        async login({ commit }, practitionerCredentials) {
          commit("auth_request");
          try {
            let { data: practitioner } = await axios.post(
              "practitioner/login",
              practitionerCredentials
            );

            localStorage.setItem("practitioner", JSON.stringify(practitioner));
            commit("auth_success", { practitioner });
            return practitioner;
          } catch (err) {
            //console.log(err);
            commit("auth_error");
            localStorage.removeItem("practitioner");
            throw err;
          }
        },
        async register({ commit }, practitioner) {
          commit("auth_request");
          try {
            let { data: practitionerCreated } = await axios.post(
              "practitioner/register",
              practitioner
            );
            localStorage.setItem(
              "practitioner",
              JSON.stringify(practitionerCreated)
            );
            commit("auth_success", { practitioner: practitionerCreated });
            return practitionerCreated;
          } catch (err) {
            commit("auth_error", err);
            localStorage.removeItem("practitioner");
            throw err;
          }
        },
        async logout({ commit }) {
          localStorage.removeItem("practitioner");
          commit("logout");
        },
        saveFromUrl({ commit }, fromUrl) {
          commit("setFromUrl", fromUrl);
        },
        setPractitioner({ commit }, practitioner) {
          commit("setPractitioner", practitioner);
        }
      },
      getters: {
        isLoggedIn: state => !!Object.keys(state.practitioner).length,
        getPractitioner: state => state.practitioner,
        getFromUrl: state => state.fromUrl
      }
    }
  }
});
